import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Card } from 'components';
import { TwButton } from 'components/TwButton/TwButton';
import H1 from 'components/H/H1';
import Sliders from 'components/Sliders/Sliders';
import useUpsaleChangeAmount from './useUpsaleChangeAmount';
import UpsaleOffer from '../Upsale/UpsaleOffer';

export default function UpsaleChangeAmount() {
  const { t } = useTranslation('upsale');
  const {
    upsaleConstraintsData,
    amount,
    onAmountChange,
    handleConfirm,
    isLoading,
    isPending,
    offer,
  } = useUpsaleChangeAmount();

  return (
    <>
      <Helmet>
        <title>{t('html_title')}</title>
      </Helmet>

      <H1>{t('title')}</H1>

      <div className="flex flex-col gap-6">
        <Card className="flex flex-col gap-6 p-5 lg:p-10">
          {upsaleConstraintsData && (
            <Sliders
              amount={amount || 0}
              constraints={upsaleConstraintsData}
              onAmountChange={onAmountChange}
            />
          )}

          <UpsaleOffer offer={offer} isLoading={isLoading} />

          <TwButton
            data-test="new-offer-btn"
            pending={isPending}
            disabled={isPending || isLoading}
            onClick={handleConfirm}
          >
            {t('button_change_amount')}
          </TwButton>
        </Card>
      </div>
    </>
  );
}
